import EditAccountApi from '../api/account/editAccountApi';
import CreateAccountApi from '../api/account/userCreationApi';
import * as errorMessages from '../constants/errorMessages';
import * as types from './actionTypes';
import {startAjaxCall, startAjaxCallError} from './ajaxStatusActions';

export function updateUserSuccessful(newInfo) {
  return {type: types.UPDATE_USER_SUCCESS, newInfo};
}

export function userRetrievedSuccess(user) {
  return {type: types.USER_RETRIEVED_SUCCESS, user};
}

export function createUserSuccessful(userCreated) {
  return {type: types.CREATE_USER_SUCCESS, userCreated};
}

export function createUserFailed(userCreated) {
  return {type: types.CREATE_USER_FAILED, userCreated};
}

export function submitUser(user) {
  return dispatch => {
    dispatch(startAjaxCall());
    return CreateAccountApi.submitUser(user).then(response => {
      if(response.userId) {
        dispatch(createUserSuccessful(true));
        return Object.assign(response);
      } else if(response.emailExists || response.usernameExists){
        let status = [];
        if(response.emailExists){
          dispatch(startAjaxCallError(errorMessages.ERROR_EMAIL_IN_USE));
          status.push("email_repeated");
        }
        if(response.usernameExists){
          dispatch(startAjaxCallError(errorMessages.ERROR_USERNAME_IN_USE));
          status.push('username_repeated');
        }
        dispatch(createUserFailed(status));
      } else {
        dispatch(startAjaxCallError(response));
        dispatch(createUserFailed(false));
      }
    }).catch(error => {
      dispatch(startAjaxCallError(error));
      dispatch(createUserFailed(false));
      throw(error);
    });
  };
}

export function updateUser(newInfo) {
  return function (dispatch) {
    dispatch(startAjaxCall());
    return EditAccountApi.updateUser(newInfo).then(response => {
      if(response.status === "success") {
        dispatch(updateUserSuccessful(newInfo));
        return Object.assign({},response);
      } else if(response.emailExists){
          dispatch(startAjaxCallError(errorMessages.ERROR_EMAIL_IN_USE));
      } else {
        dispatch(startAjaxCallError(response));
      }
    }).catch(error => {
      dispatch(startAjaxCallError(error));
      throw(error);
    });
  };
}

export function refreshToken() {
  return function (dispatch) {
    dispatch(startAjaxCall());
    return EditAccountApi.refreshToken().then(response => {
     if(response.status === "success") {
       const newUser = Object.assign({},response);
       dispatch(updateUserSuccessful(newUser));
       return "success";
     } else if(response.includes("Your token has expired")){
      dispatch(startAjaxCallError());
      return "failure";
     }else {
       dispatch(startAjaxCallError(response));
     }
    }).catch(error => {
      dispatch(startAjaxCallError(error));
      throw(error);
    });
  };
}



/** WEBPACK FOOTER **
 ** ./src/actions/userActions.js
 **/